import React from 'react';
import { Route } from 'react-router-dom';
import ServicePartnerPage from './ServicePartnerPage';

export const routes = [<Route key="0" path="/service-partner" component={ServicePartnerPage} />];

export const navigation = { name: 'service_partner', link: '/service-partner', parent: 'BoardMembers' };
